var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6049 4.19508C28.4337 4.1953 31.1466 5.31919 33.1466 7.31965C35.1466 9.31988 36.2705 12.0328 36.2705 14.8614C36.2705 17.6902 35.1469 20.4031 33.1466 22.4037C31.327 24.2117 28.9185 25.3063 26.3598 25.4882C23.8011 25.6701 21.262 24.9273 19.2049 23.3949L20.0049 22.3282C21.8051 23.6688 24.027 24.3188 26.266 24.1599C28.5051 24.0007 30.6125 23.0434 32.2049 21.4617C34.563 19.1036 35.4839 15.6668 34.6207 12.4457C33.7575 9.22451 31.2417 6.70908 28.0207 5.84565C24.7998 4.98222 21.363 5.90346 19.0047 8.26148C17.2543 10.0117 16.2708 12.3858 16.2708 14.8615C16.2708 17.3369 17.2543 19.711 19.0047 21.4615L18.0621 22.4041C16.5704 20.9124 15.5543 19.0117 15.1427 16.9425C14.7311 14.8733 14.9425 12.7285 15.7498 10.7791C16.5572 8.82971 17.9244 7.16411 19.6786 5.99205C21.4326 4.81994 23.4951 4.19451 25.6049 4.19451L25.6049 4.19508Z",
    fill: "#0041EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2796 13.8174C20.503 13.7939 22.6392 14.6826 24.1905 16.2758C26.4744 18.5598 27.1858 21.5892 26.2485 25.037L24.9619 24.6863C25.7666 21.7269 25.1739 19.145 23.2478 17.2194C21.3219 15.2942 18.7398 14.702 15.781 15.5061L15.4316 14.2194L15.4316 14.2197C16.3589 13.9598 17.3167 13.8243 18.2796 13.817L18.2796 13.8174Z",
    fill: "#0041EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1343 16.2757L23.2486 18.1614L22.3057 17.2185L24.1914 15.3328L25.1343 16.2757Z",
    fill: "#0041EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.23 19.7362L24.4019 20.68L23.98 19.4159L26.8081 18.4722L27.23 19.7362Z",
    fill: "#0041EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.605 22.8619L24.9382 22.8619L24.9382 21.5287L27.605 21.5287L27.605 22.8619Z",
    fill: "#0041EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9385 15.5282L17.6052 15.5282L17.6052 12.8615L18.9385 12.8615L18.9385 15.5282Z",
    fill: "#0041EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9946 13.6585L21.0513 16.4866L19.7863 16.0648L20.7297 13.2366L21.9946 13.6585Z",
    fill: "#0041EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9616 4.68653L26.2483 5.0372C25.4436 7.99657 26.0355 10.5791 27.9616 12.5041C29.8875 14.4289 32.4683 15.0228 35.4285 14.2181L35.7778 15.5047C32.3312 16.4427 29.3007 15.7306 27.0173 13.4467C24.734 11.1627 24.0246 8.13531 24.9619 4.68668L24.9616 4.68653Z",
    fill: "#0041EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9043 12.5048L27.0186 14.3905L26.0757 13.4476L27.9614 11.5619L28.9043 12.5048Z",
    fill: "#0041EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4233 13.6585L30.48 16.4866L29.2151 16.0648L30.1584 13.2366L31.4233 13.6585Z",
    fill: "#0041EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.605 16.8619L32.2717 16.8619L32.2717 14.1952L33.605 14.1952L33.605 16.8619Z",
    fill: "#0041EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.272 8.19507L23.6052 8.19507L23.6052 6.86181L26.272 6.86181L26.272 8.19507Z",
    fill: "#0041EB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.23 10.3077L24.4019 11.2514L23.98 9.98738L26.8081 9.04361L27.23 10.3077Z",
    fill: "#0041EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0762 21.9997L5.40988 28.666L4.46703 27.7231L11.1333 21.0568L12.0762 21.9997Z",
    fill: "#0041EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7432 19.3334L13.4101 20.6664L12.4673 19.7236L13.8003 18.3905L14.7432 19.3334Z",
    fill: "#0041EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43018 30.6458L6.07595 32L5.13309 31.0571L6.48732 29.7029L7.43018 30.6458Z",
    fill: "#0041EB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41016 28.6665L8.07713 29.9995L7.13427 29.0567L8.4673 27.7237L9.41016 28.6665Z",
    fill: "#0041EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0771 24.0002L12.0769 26.0005L11.1341 25.0576L13.1343 23.0574L14.0771 24.0002Z",
    fill: "#0041EB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0757 31.3333L12.7427 32.6663L11.7998 31.7234L13.1328 30.3904L14.0757 31.3333Z",
    fill: "#0041EB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7432 34.667L13.4101 36L12.4673 35.0571L13.8003 33.7241L14.7432 34.667Z",
    fill: "#0041EB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0771 29.3328L16.0774 33.3326L15.1345 32.3897L19.1343 28.39L20.0771 29.3328Z",
    fill: "#0041EB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0762 27.3334L20.7431 28.6664L19.8003 27.7236L21.1333 26.3905L22.0762 27.3334Z",
    fill: "#0041EB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0771 25.9997L6.07715 35.9997L5.13429 35.0568L15.1343 25.0568L16.0771 25.9997Z",
    fill: "#0041EB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0762 24.0002L16.7431 25.3333L15.8003 24.3904L17.1333 23.0574L18.0762 24.0002Z",
    fill: "#0041EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPitch);
export default __webpack_public_path__ + "static/media/icon_pitch.a23493ece3942a692aba72164d5c66a1.svg";
export { ForwardRef as ReactComponent };